import socketio from 'socket.io-client';

import config from './config';

const { socket } = config;
const io = socketio(socket.uri || 'localhost');

/**
 * @TODO
 */
io.on('update', (data) => {
  console.log('update', data);
});

export {
  io,
};



// WEBPACK FOOTER //
// ./src/lib/socket.js